import styled from 'styled-components';
export const BannerWrapper = styled.div `
  width: 100%;
`;
export const Content = styled.div `
  margin: auto var(--spacing-1) auto 0;
  width: 100%;
  gap: var(--spacing-0-5);
`;
